import { Injectable } from '@angular/core';
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  constructor(
    private readonly _router: Router,
    private readonly _authenticationService: AuthenticationService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const isLoggedIn = this._authenticationService.checkIfLoggedIn();

    if (isLoggedIn) {
      //user has token and it is not expired
      return true;
    }

    // Token is either not present, expired, or invalid
    this._router.navigate(['/login']);
    return false;
  }
}
